// extracted by css-extract-rspack-plugin
export default {"colorRed":"#ea3556","errors":"error-list__errors___uHQfC common__formLabel___Z4SDA common__specialSans___Gudrg common__bold___ve4Qa"};